/*
 * Merry Worlds – Omaggio a sorpresa
 * - Box "Regalo a sorpresa" nel carrello (drawer e pagina /cart) con avanzamento verso la soglia.
 * - Aggiunge il prodotto "Omaggio a sorpresa" (0 €) quando i prodotti, escluso l'omaggio, arrivano alla soglia,
 *   e lo toglie se il carrello scende sotto.
 * - Per evitare doppi ridisegni del carrello, quando deve aggiungere/togliere l'omaggio blocca il refresh
 *   "vecchio" del tema e ne invia uno solo, già aggiornato.
 * Configurazione: sezione "MW Omaggio carrello" (overlay group) -> #mw-omaggio-config
 */
(function () {
  'use strict';

  var config = document.getElementById('mw-omaggio-config');
  if (!config) return;

  var GIFT_VARIANT_ID = parseInt(config.getAttribute('data-variant-id'), 10);
  var GIFT_HANDLE = config.getAttribute('data-handle') || 'omaggio-a-sorpresa';
  var THRESHOLD = parseInt(config.getAttribute('data-threshold'), 10);
  if (!GIFT_VARIANT_ID || !THRESHOLD) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
  var state = { cart: null, busy: false, timer: null, blocked: null, bars: {}, lastRefresh: 0 };

  var ICON_GIFT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 11h16v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9Z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M3 8a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3H3V8Z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M12 7v14" stroke="currentColor" stroke-width="1.5"/><path d="M12 7c-1.6-2.9-5.2-3.4-5.2-1.2C6.8 7 9.4 7 12 7Zm0 0c1.6-2.9 5.2-3.4 5.2-1.2C17.2 7 14.6 7 12 7Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
  var ICON_STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 1.5l2.1 7.4L21.5 12l-7.4 2.1L12 22.5l-2.1-8.4L2.5 12l7.4-3.1L12 1.5Z" fill="currentColor"/></svg>';

  function money(cents) {
    return fmt.format(cents / 100);
  }

  function analyse(cart) {
    var res = { eligible: 0, giftQty: 0, giftKey: null, count: cart.item_count || 0 };
    (cart.items || []).forEach(function (item) {
      if (item.variant_id === GIFT_VARIANT_ID) {
        res.giftQty += item.quantity;
        res.giftKey = item.key;
      } else {
        res.eligible += item.final_line_price;
      }
    });
    return res;
  }

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function drawerEl() {
    return document.getElementById('mini-cart');
  }

  function isCartPage() {
    return !!document.querySelector('.cart .line-item-table');
  }

  /* ---------- refresh del carrello ---------- */

  // Blocca il refresh del tema (con dati vecchi) mentre stiamo aggiungendo/togliendo l'omaggio
  window.addEventListener('cart:refresh', function (e) {
    if (state.busy && !(e.detail && e.detail.mwOwn)) {
      e.stopImmediatePropagation();
      state.blocked = e.detail || {};
    }
  }, true);

  function dispatchRefresh(detail) {
    state.lastRefresh = Date.now();
    detail = detail || {};
    detail.mwOwn = true;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
  }

  // Se il carrello disegnato non corrisponde a quello reale (omaggio presente/assente), ri-disegna
  function domOutOfSync(a) {
    var drawer = drawerEl();
    var container = drawer ? drawer.querySelector('.drawer__content') : (isCartPage() ? document.querySelector('.cart') : null);
    if (!container || a.count === 0) return false;
    var shown = !!container.querySelector('.line-item a[href*="/products/' + GIFT_HANDLE + '"], .line-item a[data-mw-gift-link]');
    return shown !== (a.giftQty > 0);
  }

  /* ---------- logica omaggio ---------- */

  function sync(cart) {
    if (cart && cart.items) state.cart = cart;
    if (!state.cart || state.busy) { render(); return; }

    var a = analyse(state.cart);
    var request = null;

    if (a.eligible >= THRESHOLD && a.giftQty === 0) {
      request = { url: 'cart/add.js', body: { items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] } };
    } else if (a.eligible >= THRESHOLD && a.giftQty > 1) {
      request = { url: 'cart/change.js', body: { id: a.giftKey, quantity: 1 } };
    } else if (a.eligible < THRESHOLD && a.giftQty > 0) {
      request = { url: 'cart/change.js', body: { id: a.giftKey, quantity: 0 } };
    }

    render();

    if (!request) {
      if (domOutOfSync(a) && Date.now() - state.lastRefresh > 2500) dispatchRefresh();
      return;
    }

    // da qui in poi il refresh "vecchio" del tema viene trattenuto
    state.busy = true;
    state.blocked = null;

    var drawer = drawerEl();
    var sectionId = drawer ? drawer.getAttribute('section') : null;
    if (sectionId) {
      request.body.sections = [sectionId];
      request.body.sections_url = window.location.pathname;
    }

    var sections = null;
    post(request.url, request.body)
      .then(function (res) {
        sections = res && res.sections;
        return getCart();
      })
      .then(function (c) {
        state.cart = c;
        state.busy = false;
        render();

        if (isCartPage() && !drawer) {
          window.location.reload();
          return;
        }

        var blocked = state.blocked || {};
        state.blocked = null;
        if (sections && sectionId && sections[sectionId]) {
          c.sections = {};
          c.sections['mini-cart'] = sections[sectionId];
          dispatchRefresh({ cart: c, openMiniCart: blocked.openMiniCart, replacementDelay: 0 });
        } else {
          dispatchRefresh({ openMiniCart: blocked.openMiniCart });
        }
      })
      .catch(function () {
        state.busy = false;
        state.blocked = null;
        dispatchRefresh();
      });
  }

  /* ---------- box "Regalo a sorpresa" ---------- */

  function createBar(large) {
    var bar = document.createElement('div');
    bar.className = 'mw-gift-bar' + (large ? ' mw-gift-bar--large' : '');
    bar.setAttribute('aria-live', 'polite');
    bar.innerHTML =
      '<span class="mw-gift-bar__icon">' +
        '<span class="mw-gift-bar__i mw-gift-bar__i--gift">' + ICON_GIFT + '</span>' +
        '<span class="mw-gift-bar__i mw-gift-bar__i--star">' + ICON_STAR + '</span>' +
      '</span>' +
      '<span class="mw-gift-bar__body">' +
        '<span class="mw-gift-bar__kicker">Regalo a sorpresa</span>' +
        '<span class="mw-gift-bar__text"></span>' +
        '<span class="mw-gift-bar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100"><span class="mw-gift-bar__fill"></span></span>' +
      '</span>';
    return bar;
  }

  function updateBar(bar, a) {
    var done = a.eligible >= THRESHOLD;
    var pct = done ? 100 : Math.round(Math.min(a.eligible / THRESHOLD, 1) * 1000) / 10;
    var text = done
      ? 'Sbloccato! È già nel tuo carrello.'
      : 'Ancora <strong>' + money(THRESHOLD - a.eligible) + '</strong> e il regalo è tuo.';
    var key = done ? 'done' : 'todo-' + a.eligible;
    if (bar.getAttribute('data-key') === key) return;

    var textEl = bar.querySelector('.mw-gift-bar__text');
    var fill = bar.querySelector('.mw-gift-bar__fill');
    var track = bar.querySelector('.mw-gift-bar__track');
    var stateChanged = bar.classList.contains('mw-gift-bar--done') !== done;
    var firstPaint = !bar.hasAttribute('data-key');

    bar.setAttribute('data-key', key);
    track.setAttribute('aria-valuenow', String(Math.round(pct)));

    if (firstPaint) {
      // prima volta: nessuna animazione
      bar.classList.add('mw-gift-bar--static');
      textEl.innerHTML = text;
      fill.style.width = pct + '%';
      bar.classList.toggle('mw-gift-bar--done', done);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { bar.classList.remove('mw-gift-bar--static'); });
      });
      return;
    }

    // la barra scorre fino al nuovo valore, poi (se serve) cambia stato
    fill.style.width = pct + '%';
    if (stateChanged) {
      textEl.classList.add('is-out');
      setTimeout(function () {
        textEl.innerHTML = text;
        bar.classList.toggle('mw-gift-bar--done', done);
        textEl.classList.remove('is-out');
      }, 180);
    } else {
      textEl.innerHTML = text;
    }
  }

  function render() {
    if (!state.cart) return;
    var a = analyse(state.cart);
    var show = a.count > 0 && a.count !== a.giftQty;

    var drawer = drawerEl();
    var drawerContent = drawer && drawer.querySelector('.drawer__content');
    var header = isCartPage() ? document.querySelector('.page-header__text-wrapper') : null;

    [
      { id: 'drawer', el: drawerContent, before: drawerContent && drawerContent.querySelector(':scope > #mini-cart-form'), large: false },
      { id: 'page', el: header, before: null, large: true }
    ].forEach(function (t) {
      var bar = state.bars[t.id];
      if (!t.el || !show) {
        if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
        return;
      }
      if (!bar) bar = state.bars[t.id] = createBar(t.large);
      // lo stesso elemento viene re-inserito dopo ogni ridisegno del tema: così le transizioni restano fluide
      if (bar.parentNode !== t.el) t.el.insertBefore(bar, t.before || null);
      updateBar(bar, a);
    });

    markGiftLines();
  }

  function markGiftLines() {
    var links = document.querySelectorAll('.line-item a[href*="/products/' + GIFT_HANDLE + '"]');
    Array.prototype.forEach.call(links, function (link) {
      var line = link.closest('.line-item');
      if (line && !line.classList.contains('mw-gift-line')) line.classList.add('mw-gift-line');
      // La riga omaggio non deve portare alla pagina prodotto
      link.setAttribute('data-mw-gift-link', '');
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
    });

    // Nasconde eventuali badge sconto da 0,00 €
    var badges = document.querySelectorAll('.line-item__discount-badge');
    Array.prototype.forEach.call(badges, function (badge) {
      if (/\(-[^0-9]*0[.,]00[^0-9]*\)$/.test(badge.textContent.trim()) && badge.style.display !== 'none') {
        badge.style.display = 'none';
      }
    });
  }

  function schedule() {
    clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      if (state.busy) return;
      getCart().then(sync).catch(function () {});
    }, 250);
  }

  // Il tema Focal emette cart:updated (sincrono, prima del suo cart:refresh) a ogni modifica del carrello
  document.addEventListener('cart:updated', function (e) {
    sync(e.detail && e.detail.cart);
  });

  // Quando il tema ri-disegna il carrello: rimetti subito il box (stesso frame) e ricontrolla lo stato
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (!el || el.closest('.mw-gift-bar')) continue;
      if (el.closest('#mini-cart') || el.closest('.cart') || el.closest('.page-header')) {
        render();
        schedule();
        return;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  getCart().then(sync).catch(function () {});
})();
